import { Box, Flex, HStack, SimpleGrid } from "@chakra-ui/react";
import { Airplane } from "@airhelp/icons";
import { Container } from "components";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter/RichtextAdapter";
import type { RichtextAdapterProps } from "modules/storyblok/adapters/RichtextAdapter";
import type { ReactNode } from "react";
import type { SbEditableComponentProps } from "types/storyblok";
import type { AhTimelineProps } from "./AhTimeline.d";
import { TimeLineItem } from "./TimeLineItem/TimeLineItem";

const InnerGradient = () => (
  <Box
    h={1.5}
    bgGradient="linear-gradient(90deg, #519BFF 4.23%, #FF6B73 96.54%)"
    minW={{ base: "936px", lg: "full" }}
    pos="absolute"
  />
);

const Gradient = ({ children }: { children: ReactNode }) => (
  <HStack
    bgGradient="linear(to-r, rgba(81, 155, 255, 0.2), rgba(255, 107, 115, 0.2))"
    borderRadius="3xl"
    pos="relative"
    minW={{ base: "936px", lg: "full" }}
  >
    <InnerGradient />
    {children}
  </HStack>
);

const setBgImage = (url: string) => (url ? `url(${url})` : "unset");

const columsStyles: RichtextAdapterProps["customStyles"] = { paragraph: { color: "primary.700" } };

export const AhTimeline = ({
  heading,
  leftColumnText,
  rightColumnText,
  timeLineItems,
  bgStyle,
  sbEditable,
}: SbEditableComponentProps<AhTimelineProps>) => (
  <Container>
    <Flex
      mx={{ base: "unset", lg: 4, xl: "unset" }}
      px={{ base: 0, lg: 4, xl: 16 }}
      pt={{ base: 14, lg: 16 }}
      pb={{ base: 0, lg: 0 }}
      bg="primary.100"
      borderRadius={{ base: 0, lg: "xl" }}
      flexDir="column"
      {...sbEditable}
    >
      <Box px={{ base: 4, lg: "unset" }}>
        <RichtextAdapter content={heading} />
        <SimpleGrid columns={{ base: 1, lg: 2 }} gap={{ base: 4, lg: 16 }}>
          <RichtextAdapter content={leftColumnText} customStyles={columsStyles} />
          <RichtextAdapter content={rightColumnText} customStyles={columsStyles} />
        </SimpleGrid>
      </Box>
      <Flex
        mt={16}
        pt={{ base: 32, lg: 48 }}
        px={{ base: "40%", md: "15%", lg: 16 }}
        overflowX={{ base: "auto", xl: "unset" }}
        bgImage={setBgImage(bgStyle)}
        bgRepeat="no-repeat"
        bgSize="contain"
        pb={{ base: 28, lg: 36 }}
      >
        <Gradient>
          {timeLineItems.map(({ _uid, bottomText, logo, popoverText }) => (
            <TimeLineItem key={_uid} bottomText={bottomText} logo={logo} popoverText={popoverText} />
          ))}
          <Airplane transform="rotate(90deg)" boxSize={10} pos="absolute" right={-5} color="primary.800" />
        </Gradient>
      </Flex>
    </Flex>
  </Container>
);
